import React from "react";

import { Icon } from "semantic-ui-react";

/** Renders a Semantic UI Icon called `question circle outline`. */
export const DefaultTooltipIcon = (props) => (
  <Icon {...props} name="question circle outline" />
);
